module.exports = __webpack_public_path__ + "static/pic01-b2d89d2833087af6ccfc50ea92833389.jpg";